import styled, { css } from 'styled-components';

export const Container = styled.div`
	width: 100vw;
`;

export const Content = styled.div`
	width: 100%;
	max-width: 1352px;
	height: 100%;
	padding: 0 16px;
	box-sizing: border-box;

	display: flex;
	flex-direction: column;
	align-items: center;

	${(props) =>
		props.maxWidth &&
		css`
			max-width: ${props.maxWidth};
		`}

	@media only screen and (max-width: 767.98px) {
		max-width: none;
		padding: 0;
	}
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	width: 100%;

	${(props) =>
		props.backgroundImage &&
		css`
			background-image: url(${props.backgroundImage});
			background-position: center;
			background-size: cover;
		`}

	${(props) =>
		props.backgroundColor &&
		css`
			background-color: ${props.backgroundColor};
		`}

	${(props) =>
		props.paddingBottom &&
		css`
			padding-bottom: ${props.paddingBottom} !important;
		`}

	@media only screen and (min-width: 768px) {
		padding: 160px 0;
	}

	@media only screen and (max-width: 767.98px) {
		padding: 60px 0;
	}
`;

export const SectionTitle = styled.div`
	text-align: center;
	color: ${(props) => props.color};

	@media only screen and (min-width: 768px) {
		font-size: 42px;
		font-weight: 700;
		line-height: 62px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 18px;
		font-weight: 700;
		line-height: 28px;
	}
`;

export const ContactButton = styled.div`
	align-self: center;

	display: flex;
	align-items: center;
	justify-content: center;
	background: #4ba4f8;
	box-shadow: 2px 3px 25px rgba(0, 0, 0, 0.1);

	color: white;
	cursor: pointer;

	a {
		color: white;
	}

	@media only screen and (min-width: 768px) {
		margin-top: 60px;
		width: 300px;
		height: 80px;
		border-radius: 10px;
		font-size: 22px;
		font-weight: 700;
		line-height: 22px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
		width: 180px;
		height: 50px;
		border-radius: 5px;
		font-size: 14px;
		font-weight: 700;
		line-height: 16px;
	}
`;

export const ContactButton2 = styled.div`
	align-self: center;

	display: flex;
	align-items: center;
	justify-content: center;
	background: white;
	box-shadow: 2px 3px 25px rgba(0, 0, 0, 0.1);

	color: #4ba4f8;
	cursor: pointer;

	a {
	    color: #4ba4f8;
	}

	@media only screen and (min-width: 768px) {
		margin-top: 60px;
		width: 300px;
		height: 80px;
		border-radius: 10px;
		font-size: 22px;
		font-weight: 700;
		line-height: 22px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
		width: 180px;
		height: 50px;
		border-radius: 5px;
		font-size: 14px;
		font-weight: 700;
		line-height: 16px;
	}
`;

export const BrochureButton = styled.div`
	align-self: center;

	display: flex;
	align-items: center;
	justify-content: center;
	background: #4ba4f8;
	box-shadow: 2px 3px 25px rgba(0, 0, 0, 0.1);

	color: white;
	cursor: pointer;

	a {
		color: white;
	}

	@media only screen and (min-width: 768px) {
		margin-top: 60px;
		width: 300px;
		height: 80px;
		border-radius: 10px;
		font-size: 22px;
		font-weight: 700;
		line-height: 22px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
		width: 180px;
		height: 50px;
		border-radius: 5px;
		font-size: 14px;
		font-weight: 700;
		line-height: 16px;
	}
`;


export const FeatureCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	background: rgba(255, 255, 255, 0.95);
	box-shadow: 1px 3px 30px rgba(120, 120, 120, 0.2);
	box-sizing: border-box;

	@media only screen and (min-width: 768px) {
		width: 740px;
		padding: 40px 30px;
		border-radius: 10px;

		& + & {
			margin-top: 70px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		width: 280px;
		padding: 30px 28px;
		border-radius: 5px;

		& + & {
			margin-top: 20px;
		}
	}
`;

export const FeatureNumber = styled.div`
	color: black;

	@media only screen and (min-width: 768px) {
		font-size: 24px;
		font-weight: 700;
		line-height: 24px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 16px;
		font-weight: 700;
		line-height: 16px;
	}
`;

export const FeatureTitle = styled.div`
	margin-top: 10px;
	color: black;

	@media only screen and (min-width: 768px) {
		font-size: 32px;
		font-weight: 700;
		line-height: 32px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 20px;
		font-weight: 700;
		line-height: 30px;
	}
`;

export const FeatureDescription = styled.div`
	text-align: center;
	margin-top: 20px;
	color: black;

	@media only screen and (min-width: 768px) {
		font-size: 20px;
		font-weight: 400;
		line-height: 28px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 14px;
		font-weight: 400;
		line-height: 22px;
	}
`;

export const FeatureNote = styled.div`
	color: #9a9a9a;

	@media only screen and (min-width: 768px) {
		margin-top: 12px;
		font-size: 18px;
		font-weight: 400;
		line-height: 18px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 10px;
		font-size: 12px;
		font-weight: 400;
		line-height: 10px;
	}
`;

export const FeatureImage = styled.img`
	margin-top: 30px;
	height: auto;

	${(props) =>
		props.shadow &&
		css`
			filter: drop-shadow(2px 3px 25px rgba(0, 0, 0, 0.1));
			@media only screen and (min-width: 768px) {
				border-radius: 10px;
			}

			@media only screen and (max-width: 767.98px) {
				border-radius: 5px;
			}
		`}

	${(props) =>
		props.marginTop &&
		css`
			margin-top: ${props.marginTop};
		`}

	@media only screen and (min-width: 768px) {
		width: 680px;
	}

	@media only screen and (max-width: 767.98px) {
		width: 220px;
	}

	${(props) =>
		props.imageWidth &&
		css`
			width: ${props.imageWidth} !important;
		`}
`;
